import { createAction, props } from '@ngrx/store';

import { DateRange } from '@enums';
import { Vehicle, VehicleBatch, VehicleEvent, VehicleInsurance } from '@models';

// fetch vehicles
export const fetchVehicles = createAction('[Vehicle] Fetch Initiated');
export const fetchVehiclesSuccess = createAction(
  '[Vehicle] Fetch Success',
  props<{ vehicles: Vehicle[] }>()
);
export const fetchVehiclesFailed = createAction(
  '[Vehicle] Fetch Failed',
  props<{ error: Error }>()
);

// fetch vehicle by id
export const fetchVehicleById = createAction(
  '[Vehicle] Fetch By Id Initiated',
  props<{ vehicleId: string }>()
);
export const fetchCurrentVehicle = createAction(
  '[Vehicle] Fetch Current Vehicle Initiated'
);
export const fetchVehicleByIdSuccess = createAction(
  '[Vehicle] Fetch By Id Success',
  props<{ vehicle: Vehicle }>()
);
export const fetchVehicleByIdFailed = createAction(
  '[Vehicle] Fetch By Id Failed',
  props<{ error: Error }>()
);

// fetch current vehicle insurance
export const fetchCurrentVehicleInsurance = createAction(
  '[Vehicle] Fetch Current Vehicle Insurance Initiated'
);
export const fetchCurrentVehicleInsuranceSuccess = createAction(
  '[Vehicle] Fetch Current Vehicle Insurance Success',
  props<{ vehicleInsurance: VehicleInsurance; vehicleId: string }>()
);
export const fetchCurrentVehicleInsuranceFailed = createAction(
  '[Vehicle] Fetch Current Vehicle Insurance Failed',
  props<{ error: Error; vehicleId: string }>()
);

// assign user to vehicle
export const assignUserToVehicle = createAction(
  '[Vehicle] Assign User To Vehicle',
  props<{ vehicleId: string; userId: string }>()
);
export const assignUserToVehicleSuccess = createAction(
  '[Vehicle] Assign User To Vehicle Success',
  props<{ vehicle: Vehicle }>()
);
export const assignUserToVehicleFailed = createAction(
  '[Vehicle] Assign User To Vehicle Failed',
  props<{ error: Error }>()
);

// remove user from vehicle
export const removeUserFromVehicle = createAction(
  '[Vehicle] Remove User From Vehicle',
  props<{ vehicleId: string; userId: string }>()
);
export const removeUserFromVehicleSuccess = createAction(
  '[Vehicle] Remove User From Vehicle Success',
  props<{ vehicle: Vehicle }>()
);
export const removeUserFromVehicleFailed = createAction(
  '[Vehicle] Remove User From Vehicle Failed',
  props<{ error: Error }>()
);

// fetch vehicle events
export const fetchVehicleEvents = createAction(
  '[Vehicle] Fetch Vehicle Events By Id Initiated',
  props<{ carTrackDriverId: string; dateRange: DateRange }>()
);
export const fetchVehicleEventsSuccess = createAction(
  '[Vehicle] Fetch Vehicle Events By Id Success',
  props<{ vehicleEvents: VehicleEvent[] }>()
);
export const fetchVehicleEventsFailed = createAction(
  '[Vehicle] Fetch Vehicle Events By Id Failed',
  props<{ error: Error }>()
);

// fetch Batch by id
export const fetchVehicleBatchById = createAction(
  '[Vehicle] Fetch Batch By Id Initiated',
  props<{ batchId: string }>()
);
export const fetchVehicleBatchByIdSuccess = createAction(
  '[Vehicle] Fetch Batch By Id Success',
  props<{ batch: VehicleBatch }>()
);
export const fetchVehicleBatchByIdFailed = createAction(
  '[Vehicle] Fetch Batch By Id Failed',
  props<{ error: Error }>()
);

// process Batch
export const processVehicleBatch = createAction(
  '[Vehicle] Process Batch Initiated',
  props<{ batchId: string }>()
);
export const processVehicleBatchSuccess = createAction(
  '[Vehicle] Process Batch Success'
);
export const processVehicleBatchFailed = createAction(
  '[Vehicle] Process Batch Failed',
  props<{ error: Error }>()
);

// Fetch Batches
export const fetchVehicleBatches = createAction('[Vehicle] Fetch Batches Initiated');
export const fetchVehicleBatchesSuccess = createAction(
  '[Vehicle] Fetch Batches Success',
  props<{ batches: VehicleBatch[] }>()
);
export const fetchVehicleBatchesFailed = createAction(
  '[Vehicle] Fetch Batches Failed',
  props<{ error: Error }>()
);

// Create Batch
export const createVehicleBatch = createAction(
  '[Vehicle] Create Batch Initiated',
  props<{ file: File }>()
);
export const createVehicleBatchSuccess = createAction(
  '[Vehicle] Create Batch Success',
  props<{ batch: VehicleBatch }>()
);
export const createVehicleBatchFailed = createAction(
  '[Vehicle] Create Batch Failed',
  props<{ error: Error }>()
);
